export enum END_OF_TERM_CHANGE {
  YES = 'yes',
  NO = 'no',
  NOT_SURE = 'notSure',
}
